import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { useMemo, useCallback } from 'react';
import MuiBox from '@mui/material/Box';
import { styled } from '@mui/material';
import Hint from '../Hint/Hint.js';
import { ReactComponent as ForwardRef$3 } from '../../assets/icons/BackSmall.svg.js';
import { ReactComponent as ForwardRef } from '../../assets/icons/BackToSmall.svg.js';
import { ReactComponent as ForwardRef$2 } from '../../assets/icons/NextSmall.svg.js';
import { ReactComponent as ForwardRef$1 } from '../../assets/icons/NextToSmall.svg.js';

const Root = styled(MuiBox) `
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  transition: color ${({ theme }) => theme.transitions.duration.fast} linear;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  margin: ${({ theme, type }) => theme.spacing(0, 0, 0, type === 'next' ? 1 : 0)};
  color: ${({ theme, disabled }) => theme.palette[disabled ? 'N30' : 'N20'].main};
  ${({ theme, disabled }) => !disabled &&
    `
    &:hover {
      color: ${theme.palette.primary.main};
    }
  `};
`;
const ICONS = {
    first: ForwardRef,
    last: ForwardRef$1,
    next: ForwardRef$2,
    previous: ForwardRef$3,
};
const PaginationIcon = (_a) => {
    var { type, disabled, onClick, hint } = _a, rest = __rest(_a, ["type", "disabled", "onClick", "hint"]);
    const Icon = useMemo(() => ICONS[type], [type]);
    const onClinkInternal = useCallback((e) => {
        if (!disabled) {
            onClick(e);
        }
    }, [onClick, disabled]);
    return (jsx(Hint, Object.assign({ title: hint, disabled: disabled }, { children: jsx(Root, Object.assign({ disabled: disabled, type: type, onClick: onClinkInternal, "data-testid": `${type}-button` }, rest, { children: jsx(Icon, {}) })) })));
};

export { PaginationIcon as default };
//# sourceMappingURL=PaginationIcon.js.map
